<template>
  <div :class="['v-card', borderedCard]">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    bordered: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    borderedCard() {
      return this.bordered ? "v-card-bordered" : "";
    }
  }
};
</script>
